import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';

// Password reset functionality
export const sendPasswordReset = async (email: string) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true, message: 'Password reset email sent successfully' };
  } catch (error: any) {
    console.error('Error sending password reset email:', error);
    throw error;
  }
};